import Vue from "vue";
import Vuex from "vuex";
import { service } from "@/_services/Account/Setting/account-setting.service.js";

Vue.use(Vuex);
const moduleImageResource = {
  namespaced: true,
  state: {
    uploadedFiles: []
  },
  mutations: {
    storedData(state, data) {
      state.uploadedFiles = [...data];
    }
  }
};
const moduleHeader = {
  namespaced: true,
  state: {
    user: {},
    logoHotel: null,
  },
  mutations: {
    storedUserInfo(state, data) {
      state.user = data.user;
      state.logoHotel = data.logo;
    }
  },
  actions: {
    async dispatchUserInfo() {
      let user = await service.getProfile().data;
      // console.log(user)
    }
  }
}
const moduleTargetImage = {
  namespaced: true,
  state: {
    justUploaded: [],
    preparedTargetImage: [],
    uploadedFiles: []
  },
  mutations: {
    storedListJustUploaded(state, data) {
      state.justUploaded = data;
    },
    storedListpreparedTargetImage(state, data) {
      state.preparedTargetImage = data;
    },
    storedHotelImage(state, data) {
      state.uploadedFiles = data;
    }
  }
};

const moduleAlert = {
  namespaced: true,
  state: {
    success: false,
    error: false,
    warning: false,
    message: ""
  },
  mutations: {
    display(state, data) {
      if (state.message && data && !data.message) {
        state.message = data.message;
        state.success = data.success;
        state.warning = data.warning;
        state.error = data.error;
        state.res = data.res;
        return true;
      }
      if (!state.message && data && typeof (data.message) == "string") {
        state.message = data.message;
        state.success = data.success;
        state.warning = data.warning;
        state.error = data.error;
        state.res = data.res;
        return true;
      }
      if (!state.message && data && data.message && data.message.length) {
        state.message = data.message[0];
        state.success = data.success;
        state.error = data.error;
        state.warning = data.warning;
        state.res = data.res;
      }
    }
  }
};
const moduleAlertLink = {
  namespaced: true,
  state: {
    success: false,
    error: false,
    message: "",
    link: "",
  },
  mutations: {
    display(state, data) {
      if (state.message && data && !data.message) {
        state.message = data.message;
        state.success = data.success;
        state.error = data.error;
        state.res = data.res;
        state.link = data.link;
        return true;
      }
      if (!state.message && data && typeof (data.message) == "string") {
        state.message = data.message;
        state.success = data.success;
        state.error = data.error;
        state.res = data.res;
        state.link = data.link;
        return true;
      }
      if (!state.message && data && data.message && data.message.length) {
        state.message = data.message[0];
        state.success = data.success;
        state.error = data.error;
        state.res = data.res;
        state.link = data.link;
      }
    }
  }
};
const modulesRegister = {
  state: {
    personDetail: [],
    hotelDetail: [],
    createAccount: []
  },
  mutations: {
    storePersonData(state, data) {
      state.personDetail = data;
    },
    storeHoteltData(state, data) {
      state.hotelDetail = data;
    },
    storeAccountData(state, data) {
      state.createAccount = data;
    }
  }
};
export default new Vuex.Store({
  modules: {
    imageResource: moduleImageResource,
    hotelImage: moduleTargetImage,
    modulesRegister,
    alert: moduleAlert,
    alertLink: moduleAlertLink,
    user: moduleHeader,
  },
  state: {
    imageGallary: []
  },

  mutations: {
    storedImageGallary(state, data) {
      state.imageGallary = data;
    }
  },

  actions: {}
});
